import * as providersMap from "@teacherskaya/api-provider/dist";
import config from "@/config";
import providersConf from "./providers.conf";
import emitter from "@/lib/helpers/emitter";
import appStorage from "@/lib/appStorage";

const url = `${config.apiUrl || "/graphql"}`;

const providers = providersMap[providersConf.project]({
  prefix: "admin",
  websocketOnly: true,
  url,
  appStorage: {
    getString(key: string, defaultValue: string) {
      return appStorage.getString(key, defaultValue);
    },
    setString(key: string, value: string) {
      return appStorage.setString(key, value);
    },
  },
  notificationCB: (event, payload) => emitter.emit(event, payload),
});

export default providers.providers;
